import { useEffect, useState } from "react";

function AdminDashboard({ setAdminPage }) {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    fetch("https://high-and-fly-1.onrender.com/api/contact/product/list/")
      .then((res) => res.json())
      .then((data) => setProducts(data));
  }, []);

  const deleteProduct = async (id) => {
    try {
      await fetch(
        `https://high-and-fly-1.onrender.com/api/contact/product/delete/${id}/`,
        {
          method: "DELETE",
        }
      );

      setProducts(prev => prev.filter(p => p.id !== id));
    } catch (err) {
      console.error("Delete failed:", err);
    }
  };

  const logout = () => {
    localStorage.removeItem("adminToken");
    setAdminPage("/login");
  };
  const filteredProducts = products.filter(p => p.origin === "HighnFly");

  return (
    <div>
      <h1>Admin Dashboard</h1>

      <button onClick={logout}>Logout</button>

      <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", marginTop: "20px" }}>
        {filteredProducts.map((p) => (
          <div key={p.id} style={cardStyle}>
            {p.image && (
              <img
                src={`https://high-and-fly-1.onrender.com${p.image}`}
                alt={p.name}
                style={{ width: "100%", height: "150px", objectFit: "cover" }}
              />
            )}

            <h3>{p.name}</h3>
            <p>{p.description}</p>
            <p><b>${p.price}</b></p>
            <p>Qty: {p.quantity}</p>

            {/* DELETE BUTTON */}
            <button
              onClick={() => deleteProduct(p.id)}
              style={deleteBtn}
            >
              ✕
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AdminDashboard;

const cardStyle = {
  width: "200px",
  padding: "10px",
  border: "1px solid #ddd",
  borderRadius: "10px",
  background: "white",
  position: "relative"
};

const deleteBtn = {
  position: "absolute",
  top: "8px",
  right: "8px",
  width: "25px",
  height: "25px",
  borderRadius: "50%",
  border: "none",
  background: "red",
  color: "white",
  cursor: "pointer",
  fontWeight: "bold"
};